import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { NycCosContainer } from '../../Styled';
import { NycCo } from '../../types';
import PerItemDisplay from './PerItemDisplay';
import { TableHeader } from '../TableHeader';

interface PropTypes {
  nycCos: NycCo[];
}

const TableRow = ({
  nycCo,
  onClick,
  showBackgroundColor,
}: {
  nycCo: NycCo;
  onClick: React.Dispatch<React.SetStateAction<NycCo>>;
  showBackgroundColor: boolean;
}) => (
  <Table.Row
    onClick={() => onClick(nycCo)}
    style={{ backgroundColor: showBackgroundColor ? 'lightgrey' : '#fff', cursor: 'pointer' }}
  >
    <Table.Cell width={3}>{nycCo.date}</Table.Cell>
    <Table.Cell width={3}>{nycCo.number}</Table.Cell>
    <Table.Cell width={3}>{nycCo.street}</Table.Cell>
    <Table.Cell width={7}>{nycCo.coLang}</Table.Cell>
  </Table.Row>
);

const NycCoTab = (props: PropTypes) => {
  const [itemToDisplay, setItemToDisplay] = useState<NycCo>(null);
  const [indexToHighlight, setIndexToHighlight] = useState(null);
  const [sortedCos, setSortedCos] = useState<NycCo[]>([]);

  useEffect(() => {
    if (props.nycCos) {
      setSortedCos(props.nycCos);
    }
  }, [props.nycCos]);

  return (
    <React.Fragment>
      {props.nycCos.length === 0 ? (
        <div>No Records Available</div>
      ) : (
        <NycCosContainer>
          <Table
            style={{ width: itemToDisplay ? '65%' : '100%' }}
            striped
            selectable
            fixed
            singleLine
            sortable
          >
            <TableHeader
              columnNames={['Date', 'Number', 'Street', 'Co Lang']}
              sortedData={sortedCos}
              setSortedData={setSortedCos}
            />
            <Table.Body>
              {sortedCos.map((co, index) => (
                <TableRow
                  onClick={e => {
                    setItemToDisplay(e);
                    setIndexToHighlight(index);
                  }}
                  nycCo={co}
                  showBackgroundColor={index === indexToHighlight}
                />
              ))}
            </Table.Body>
          </Table>
          {itemToDisplay && <PerItemDisplay nycCo={itemToDisplay} />}
        </NycCosContainer>
      )}
    </React.Fragment>
  );
};

export default NycCoTab;
